import { render, staticRenderFns } from "./extract-modal.vue?vue&type=template&id=778b8cad&scoped=true&"
import script from "./extract-modal.vue?vue&type=script&lang=js&"
export * from "./extract-modal.vue?vue&type=script&lang=js&"
import style0 from "./extract-modal.vue?vue&type=style&index=0&id=778b8cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b8cad",
  null
  
)

export default component.exports